module.exports = __webpack_public_path__ + "img/bee_flying.0c343e89.gif";